
const Error404 = () => {
    return (
        <>
            <div className="404">
                <div className="container-fluid">
                    <h1 style={{marginBottom: '15px' , color : '#f00'}}>Oops!</h1>
                    <h4 style={{marginBottom: '10px'}}>404 - Page not fund</h4>
                    <p>The page you are looking might have been removed had its name change or temporarily unavailable.</p>
                </div>
            </div>
        </>
    )
}

export default Error404
